module.exports = __webpack_public_path__ + "static/media/camera_off.418ccb00.svg";